/**
 * Dashboard API functions for aggregated metrics
 */

import apiClient from './client';

export interface TimeSeriesDataPoint {
  date: string;
  value: number;
}

export interface DashboardTimeSeries {
  totalSessions: TimeSeriesDataPoint[];
  qualificationRate: TimeSeriesDataPoint[];
  avgDuration: TimeSeriesDataPoint[];
  highIntentLeads: TimeSeriesDataPoint[];
}

export interface SourceCount {
  source: string;
  count: number;
}

export interface DashboardMetricsResponse {
  totalDemos: number;
  qualificationRate: number;
  qualifiedCount: number;
  unqualifiedCount: number;
  avgSessionLengthSeconds: number;
  highIntentLeads: number;
  bookedCount: number;
  activeCount: number;
  inactiveCount: number;
  mobileCount: number;
  desktopCount: number;
  topSources: SourceCount[];
  timeSeries: DashboardTimeSeries;
}

/**
 * Get aggregated dashboard metrics for an organization
 */
export async function getDashboardMetrics(
  organizationId: string,
  days: number = 30
): Promise<DashboardMetricsResponse> {
  const response = await apiClient.get<DashboardMetricsResponse>(
    `/api/dashboard/organizations/${organizationId}/metrics`,
    { days }
  );

  if (!response.success || !response.data) {
    throw new Error(response.error || 'Failed to fetch dashboard metrics');
  }

  return response.data;
}
